import { CommonFunctions } from "../static/common-functions";
import { InvoiceBus } from './InvoiceBus'
import { v_InvoiceNoteBus } from "./v_InvoiceNoteBus";
import { v_InvoiceLineItemBus } from "./v_InvoiceLineItemBus";
import { AttachmentBus } from "./AttachmentBus";
import { v_InvoiceEquipmentBus } from "./v_InvoiceEquipmentBus";
import { InvoiceCollectionNotesBus } from "./InvoiceCollectionNotesBus";
import { InvoiceNoteBus } from "./InvoiceNoteBus";
import { InvoiceCheckListBus } from "./InvoiceCheckListBus";
import { ConstructionCredits } from "../enums/ConstructionCredits";

export class InvoiceSaveParam extends InvoiceBus {
    constructor(data: InvoiceBus) {
        super(data);
    }
    setNotes(busObjs: InvoiceNoteBus[]) {

    }
    setLineItems(busObjs: v_InvoiceLineItemBus[]) {

    }
    setAttachments(busObjs: AttachmentBus[]) {

    }
    setInvoiceEquipment(busObjs: v_InvoiceEquipmentBus[]) {

    }
    setInvoiceCollectionNotes(busObjs: InvoiceCollectionNotesBus[]) {

    }
    notes: InvoiceNoteBus[];
    lineItems: v_InvoiceLineItemBus[];
    attachments: AttachmentBus[];
    invoiceEquipment: v_InvoiceEquipmentBus[];
    collectionNotes: InvoiceCollectionNotesBus[];
    drawPartsIds: any[];
    checkList: InvoiceCheckListBus[];
    constructionCreditType: ConstructionCredits = ConstructionCredits.None;

}
